import {  GetAllValutazioniFiltersDTO, GetAllValutazioniResponseData } from "./dto";
import { MonitoringValutazioniImpl } from "./serviceImpl";


export interface MonitoringValutazioniService {
    GetAllValutazioni(filters: GetAllValutazioniFiltersDTO): Promise<GetAllValutazioniResponseData[]>
}

export function NewMonitoringValutazioniService(): MonitoringValutazioniService {
    return new MonitoringValutazioniImpl()
}